<template>
  <div class="h-full flex flex-col">
    <Title title="Description" />
    <!-- ITEM CONTAINER -->
    <div class="relative h-full overflow-y-auto pb-28">
      <!-- HEADER DIV -->
      <div
        class="relative shadow-md rounded-br-bnb h-1/2 sm:h-2/3 rounded-bl-bnb"
      >
        <img
          v-if="imageUrl"
          alt="image"
          class="absolute top-0 object-cover h-full w-full rounded-br-bnb"
          :src="imageUrl"
        />
        <img
          v-else
          alt="image"
          class="h-full w-full object-contain"
          src="@/assets/logograysquare.png"
        />
        <img
          v-if="isFavourite"
          @click="removeFavourite"
          class="
            h-14
            border border-white
            z-50
            absolute
            bg-black
            rounded-full
            bg-opacity-70
            -bottom-7
            p-1
            right-4
          "
          src="@/assets/icons/heartsfill.svg"
        />
        <img
          v-else
          @click="addFavourite"
          class="
            border border-white
            h-14
            z-50
            absolute
            bg-black
            rounded-full
            bg-opacity-50
            -bottom-7
            p-2
            right-4
          "
          src="@/assets/icons/heart.svg"
        />
        <!-- IMAGES DIV -->
      </div>
      <!-- BODY DIV -->
      <div class="relative p-4 space-y-6">
        <img
          alt="image"
          class="absolute -top-0 h-9 left-0"
          src="@/assets/logofullblack.png"
        />
        <div class="flex flex-col justify-betweenitems-center">
          <p
            class="text-black text-left capitalize my-2 font-semibold text-2xl"
          >
            {{ title }}
          </p>
          <p
            class="
              px-2
              mr-auto
              font-bold
              text-2xl
              rounded-sm
              text-bnb-mustard
              bg-gray-100
              py-1
            "
          >
            ₦{{ price }}
          </p>
        </div>
        <!-- CUSTOMIZE MENU -->
        <CustomizeMenu
          :options="$store.getters.menuItem(menuID)?.options"
          @customized="customize"
        />
        <!-- DESCRIPTION DIV -->
        <div>
          <p class="text-left text-bnb-brown">Description</p>
          <p class="text-left">
            {{ description }}
          </p>
          <!-- NOTES DIV -->
          <p
            v-if="$store.getters.menuItem(menuID)?.note"
            class="text-left mt-4"
          >
            <span class="text-bnb-brown">Note:&nbsp;</span
            ><span class="text-sm">{{
              $store.getters.menuItem(menuID)?.note
            }}</span>
          </p>
          <p class="flex text-bnb-mustard font-semibold text-xs my-4">*All meals for Delivery/ Pick up include a take away pack charge*</p>
        </div>
        <!-- REVIEWS DIV -->
        <Reviews :menuID="menuID" />
      </div>
      <!-- CART BUTTON -->
      <button
        @click="runCartLogic"
        :class="[isCarted ? 'bg-bnb-mustard' : 'bg-gray-500']"
        class="
          fixed
          z-50
          bottom-8
          right-4
          flex
          space-x-2
          items-center
          focus:outline-none
          shadow-md
          border border-white
          outline-none
          text-white
          p-2
          font-semibold
          text-lg
          rounded-lg
        "
      >
        <img
          v-if="isCarted"
          alt="image"
          class="h-6"
          src="@/assets/icons/cart.svg"
        />
        <img
          v-else
          alt="image"
          class="h-6 animate-bounce"
          src="@/assets/icons/addtocart.svg"
        />
        <p v-if="isCarted">Added</p>
        <p v-else>Add to Cart</p>
      </button>
    </div>
  </div>
</template>
<script>
import Title from "@/components/Title.vue";
import { Dialog } from "@capacitor/dialog";
import CustomizeMenu from "@/views/menu/CustomizeMenu";
import Reviews from "@/views/menu/Reviews";
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";
export default {
  components: { Title, CustomizeMenu, Reviews },
  created() {
    this.fetchCachedImage();
    this.checkIfFavourite();
    this.checkIfCarted();
  },
  props: { menuID: String },
  data() {
    return {
      customizedID: "",
      isCarted: false,
      isFavourite: false,
      imageUrl: "",
    };
  },
  computed: {
    title() {
      return (
        this.$store.getters.menuItem(this.customizedID)?.title ??
        this.$store.getters.menuItem(this.menuID)?.title
      );
    },
    price() {
      return (
        this.$store.getters.menuItem(this.customizedID)?.price ??
        this.$store.getters.menuItem(this.menuID)?.price
      );
    },
    description() {
      return (
        this.$store.getters.menuItem(this.customizedID)?.description ??
        this.$store.getters.menuItem(this.menuID)?.description
      );
    },
  },
  methods: {
    fetchCachedImage() {
      var title =
        this.$store.getters.menuItem(this.customizedID)?.title ??
        this.$store.getters.menuItem(this.menuID)?.title;
      var urlImage =
        this.$store.getters.menuItem(this.customizedID)?.imageUrl ??
        this.$store.getters.menuItem(this.menuID)?.imageUrl;
      Filesystem.readFile({
        path: `menuImages/${title}`,
        directory: Directory.Data,
        encoding: Encoding.UTF8,
      })
        .then((result) => {
          this.imageUrl = result.data.slice(result.data.indexOf("data:image/"));
        })
        .catch(() => {
          this.imageUrl = urlImage;
        });
    },
    checkIfFavourite() {
      try {
        this.isFavourite =
          JSON.parse(localStorage.favourites).indexOf(this.menuID) > -1;
      } catch (error) {
        this.isFavourite = false;
      }
    },
    checkIfCarted() {
      try {
        this.isCarted =
          JSON.parse(localStorage.cart).indexOf(
            this.customizedID || this.menuID
          ) > -1;
      } catch (error) {
        this.isCarted = false;
      }
    },
    customize(id) {
      this.customizedID = id;
      this.fetchCachedImage();
      this.checkIfCarted();
    },
    runCartLogic() {
      if (this.$store.getters.menuItem(this.menuID)?.options) {
        if (this.customizedID) {
          this.addToCart(this.customizedID);
        } else {
          this.$toast.error("Please Customize", {
            position: "bottom",
            duration: 1000,
          });
        }
      } else {
        this.addToCart(this.menuID);
      }
      this.checkIfCarted();
    },
    addFavourite() {
      var id = this.menuID;
      if (id) {
        try {
          var favourites = JSON.parse(localStorage.favourites);
          if (favourites.indexOf(id) == -1) {
            favourites.push(id);
            localStorage.favourites = JSON.stringify(favourites);
            this.checkIfFavourite();
            this.$toast.show("Added to Favourites!", {
              position: "bottom",
              duration: 1000,
            });
          }
        } catch (error) {
          favourites = [id];
          localStorage.favourites = JSON.stringify(favourites);
          this.checkIfFavourite();
          this.$toast.show("Added to favourites!", {
            position: "bottom",
            duration: 1000,
          });
        }
      }
    },
    removeFavourite() {
      var id = this.menuID;
      if (id) {
        try {
          var favourites = JSON.parse(localStorage.favourites).filter(
            (e) => e != id
          );
          localStorage.favourites = JSON.stringify(favourites);
          this.checkIfFavourite();
          this.$toast.show("Removed from Favourites!", {
            position: "bottom",
            duration: 1000,
          });
        } catch (error) {
          console.error("Error removing favourite: ", error);
        }
      }
    },
    addToCart(id) {
      if (id) {
        try {
          var cart = JSON.parse(localStorage.cart);
          if (cart.indexOf(id) == -1) {
            cart.push(id);
            localStorage.cart = JSON.stringify(cart);
            this.$toast.info("Added to Cart!", {
              position: "bottom",
              duration: 1000,
            });
          } else {
            this.$toast.error("Already in Cart!", {
              position: "bottom",
              duration: 1000,
            });
          }
        } catch (error) {
          cart = [id];
          localStorage.cart = JSON.stringify(cart);
          this.$toast.info("Added to Cart!", {
            position: "bottom",
            duration: 1000,
          });
        }
      } else {
        Dialog.alert({
          title: "Wait",
          message: "Please allow content to load",
        });
      }
    },
  },
};
</script>
